var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"publicBlank",attrs:{"id":"publicBlank"}},[_c('img',{attrs:{"src":require("@/assets/images/app/nothingmore.png"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.textString))])])}
var staticRenderFns = []

export { render, staticRenderFns }